import React from "react";
import FA from "../../containers/fa";
import "./SmallInputPopup.scss";

/**
 * SmallInputPopupContainer standardizes a commonly recycled set of wrappers.
 * This one, unlike the InfoPopup, is designed to incorporate child components.
 * Because the pdf upload wrappers have a tendency to override mui components,
 * it was necessary to isolate the css into a file with higher priority,
 * SmallInputPopup.scss.
 * It's used by the following:
   <SmallInputPopupContainer
    popupHeader='Put a caption here'
    busy={put bool logic here}
    setShowModal={put popup close function here}
   >
    <>
    place any popup body contents you want here...
    </>
   </SmallInputPopupContainer>
 * @param {*} popupHeader the caption at the top of the popup.
 * @param {*} busy to indicate if the page is busy or loading.
 * @param {Function} setShowModal to close the popup.
 * @param {Array} children this is auto-generated based on the contents inside
 * the <SmallInputPopupContainer> tag.
 * @returns
 */
const SmallInputPopupContainer = ({
  popupHeader,
  busy,
  setShowModal,
  children,
}) => {
  return (
    <div className='small_popup_gray_backdrop'>
      <div className='small_popup_wrapper'>
        <div className='common_border'>
          <div className='common_heading'>
            <p>{popupHeader}</p>
            <button
              className='pdf_popup_close'
              onClick={() => {
                if (busy) {
                  return;
                }
                setShowModal(false);
              }}
            >
              <FA icon='times' />
            </button>
          </div>
          <div className='common_dashboard_bg'>
            <div className='row'>
              <div className='col-12'>{children}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SmallInputPopupContainer;
